<template>
  <!--专家指定申报评审页面子组件，显示该申报下的所有申报项目，传入参数为指定申报所有信息，并调用子组件ProjMark进行专家评分-->
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="teal">group</v-icon>
      已提交申报的项目
      <v-spacer/>
    </v-card-title>

    <v-card-text class="pt-0">
      <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0 dense"
          no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td class="">{{ props.item.reviewProj.name }}</td>
          <td class="">{{ props.item.subject.name }}</td>

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { curProjId =props.item.projId,curReviewId = props.item.reviewId, mark = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>评审</span>
          </v-tooltip>

        </template>
      </v-data-table>
    </v-card-text>

    <ProjMark
       v-model= "mark"
       :mark = "mark"
       :proj-id = "curProjId"
       :review-id = "curReviewId"
       :template-id = "curTemplateId"
       :expert-id = "expert.dbid"
       :if-anonymous-loose-leaf = "curIfAnonymousLooseLeaf"
       v-on:ok="onOk"
    >
    </ProjMark>


  </v-card>
</template>

<script>
const baseUri = '/api/proj/review';
const expertUri ='/api/syst/expert'
import ProjMark from "@/components/proj/review/ProjMark";
export default {
  name: "DeclareProjMark",
  components:{ProjMark},
  props:['reviewId'],
  data: () => ({

    items: [],

    expert: [],

    headers: [
      {text: '#', sortable: false, value: 'rank', width: 18},
      {text: '项目名称', value: 'name', sortable: false},
      {text: '项目名称', value: 'subject', sortable: false},
      {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "60"}
    ],

    markDbid: null,
    mark: false,
    curProjId: null,
    curReviewId : null,
    curTemplateId : null,
    curIfAnonymousLooseLeaf: '否',
  }),
  watch: {
    reviewId(reviewId) {
      window.console.log("监听启动9")
      window.console.log(reviewId)
      this.curTemplateId =  reviewId.templateId
      this.curIfAnonymousLooseLeaf = reviewId.ifAnonymousLooseLeaf
      let t = "dec"
      window.console.log(`${baseUri}/${t}/${reviewId.dbid}`)
      this.axios
          .get(`${baseUri}/${t}/${reviewId.dbid}`)
          .then(rsp => {
            window.console.log(rsp.status)
            if (rsp.status == 200) {
              this.items = rsp.data.items
              window.console.log("申报项目！")
              window.console.log(this.items)
            }
          })

      this.axios
          .get(`${expertUri}/expert`)
          .then(rsp => {
            window.console.log(rsp.status)
            if (rsp.status == 200) {
              this.expert = rsp.data
              window.console.log("获取专家！")
              window.console.log(this.expert)
            }
          })
    }
  },
  methods: {
    onOk() {
      this.mark = false
    },
  }
}
</script>

<style scoped>

</style>